module.exports = __webpack_public_path__ + "static/media/me_wedding.0f42e435.jpg";